import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterVolt"
    ,pure: false
})
export class FilterVolt implements PipeTransform {
    transform(inputValue:any):any {
        if(!inputValue){
            return 0;
        }
        return inputValue * 0.1;
    }
}
